import Error404 from '../assets/error-404.svg'
import Error500 from '../assets/warning.svg'

export default function ErrorImage({code}) {
  switch (code) {
    case 404:
      return (
        <img 
          src={Error404}
          alt='404-Error'
          className='error-image'
        />
      )
      
    default:
      return (
        <img 
          src={Error500}
          alt='500-Error'
          className='error-image'
        />
      )
      
  }
}